import { useState, useEffect } from 'react';
import { NavDropdown } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { useTranslation } from 'react-i18next';
import CleaningServicesModal from './services/CleaningServicesModal';
import ElectricalServicesModal from './services/ElectricalServicesModal';
import HydraulicServicesModal from './services/HydraulicServicesModal';
import PipelineServicesModal from './services/PipelineServicesModal';
import ValvesServicesModal from './services/ValvesServicesModal';
import LanguageSwitcher from './LanguageSwitcher';

const AppHeader = (props) => {
  const { t } = useTranslation();
  const logo = require('../assets/images/logo/logo.png');

  const [pipelineShow, setPipelineShow] = useState(false);
  const [clearningShow, setCleaningShow] = useState(false);
  const [hydraulicShow, setHydraulicShow] = useState(false);
  const [electricalShow, setElectricalShow] = useState(false);
  const [valvesShow, setValvesShow] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // Apply the same background as when scrolling when menu is open
  useEffect(() => {
    const header = document.querySelector('#header');
    if (menuOpen) {
      header.classList.add('bg-dark');
      header.classList.add('header-sticky');
    } else if (window.scrollY <= 50) {
      // Only remove if we're not scrolled down
      header.classList.remove('bg-dark');
      header.classList.remove('header-sticky');
    }
  }, [menuOpen]);

  return (
    <>
      <Navbar 
        bg="dark" 
        expand="lg" 
        variant="dark" 
        collapseOnSelect
        onToggle={(expanded) => setMenuOpen(expanded)}
      >
        <Container>
          <Navbar.Brand href="#home">
            <img src={logo}
              height="50"
              width="61"
              alt={t('logoAlt')}
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link href="#home">{t('home')}</Nav.Link>
              <Nav.Link href="#about">{t('about')}</Nav.Link>
              <NavDropdown align="end" title={t('services')} id="basic-nav-dropdown">
                <NavDropdown.Item onClick={() => setPipelineShow(true)}>{t('pipelineServices')}</NavDropdown.Item>
                <NavDropdown.Item onClick={() => setCleaningShow(true)}>{t('cleaningServices')}</NavDropdown.Item>
                <NavDropdown.Item onClick={() => setHydraulicShow(true)}>{t('hydraulicServices')}</NavDropdown.Item>
                <NavDropdown.Item onClick={() => setElectricalShow(true)}>{t('electricalServices')}</NavDropdown.Item>
                <NavDropdown.Item onClick={() => setValvesShow(true)}>{t('valveServices')}</NavDropdown.Item>
              </NavDropdown>
              <Nav.Link href="#contact">{t('contact')}</Nav.Link>
            </Nav>
            <LanguageSwitcher />
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <PipelineServicesModal
        show={pipelineShow}
        onHide={(title) => {
          setPipelineShow(false)
          props.navigateToContacts(title)
        }}
      />
      <CleaningServicesModal
        show={clearningShow}
        onHide={(title) => {
          setCleaningShow(false)
          props.navigateToContacts(title)
        }}
      />
      <HydraulicServicesModal
        show={hydraulicShow}
        onHide={(title) => {
          setHydraulicShow(false)
          props.navigateToContacts(title)
        }}
      />
      <ElectricalServicesModal
        show={electricalShow}
        onHide={(title) => {
          setElectricalShow(false)
          props.navigateToContacts(title)
        }}
      />
      <ValvesServicesModal
        show={valvesShow}
        onHide={(title) => {
          setValvesShow(false)
          props.navigateToContacts(title)
        }}
      />
    </>
  );
}

export default AppHeader;
